












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import PasswordIndicator from './PasswordIndicator.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ChangePasswordForm',
  components: {
    PasswordIndicator,
  },
})
export default class ChangePasswordForm extends Vue {
  private showPassword: boolean = false;
  private showPasswordConfirm: boolean = false;
  private showPasswordCriteriaText: boolean = false;
  @Prop() changePassword;
  @Prop() changePasswordRequest;
  @Prop() errors;

  $wlToastr: any;

  private errorString: string = '';

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }


  get isResetPasswordDisabled() {
    if (
      !this.changePasswordRequest.confirmPassword ||
      !this.changePasswordRequest.newPassword ||
      this.errors.newPassword ||
      this.errors.confirmPassword
    ) {
      return true;
    }
    return false;
  }

  passwordStatus(value) {
    if (!value) {
      this.errors.newPassword =
        this.$t('password-does-not-satisfy-min-requirement');
    } else {
      this.errors.newPassword = '';
    }
  }

  setShowPassword() {
    this.showPassword = !this.showPassword;
  }

  setShowPasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  async continueToAccount() {
    let userAccountStatus = vxm.users.UserAccountStatus;
    if (userAccountStatus && userAccountStatus === 'ACCOUNT_LOCKED') {
      // the below API call will unlock the user account
      vxm.users.sePwdAcctStatus(true);
    }
    // Complete user login (redirect to home remove otp token)
    await vxm.users.completeOtpLogin();
  }

  passwordMatch(forceValidation: boolean = true) {
    if (!(this.errors.confirmPassword || forceValidation)) return;

    if (
      this.changePasswordRequest.confirmPassword !==
      this.changePasswordRequest.newPassword
    ) {
      this.errors.confirmPassword = this.$t('password-does-not-match-text');
    } else {
      this.errors.confirmPassword = null;
    }
  }

  removePasswordCriteriaTextSection() {
    this.showPasswordCriteriaText = false;
  }

  togglePasswordCriteriaTextSection() {
    this.showPasswordCriteriaText = true;
  }
}
